"use client";

import { cn } from "~/lib/utils";
import Paragraph from "~/componentsDS/Typography/Paragraph";
import { InteractiveTimelineStep } from "./types";
import TimelineDot from "./TimelineDot";

type MobileWeekNavProps = {
    steps: InteractiveTimelineStep[];
    activeStep: number;
    onStepClick: (index: number) => void;
    panelId: string;
    alwaysVisible?: boolean;
};

const MobileWeekNav = ({ steps, activeStep, onStepClick, panelId, alwaysVisible = false }: MobileWeekNavProps) => {
    return (
        <div role="tablist" aria-label="Timeline weeks" className={cn("relative flex items-center justify-around w-full mt-[-10px]", !alwaysVisible && "lg:hidden")}>
            <div className="absolute top-4 left-0 right-0 h-px bg-primary500" />

            {steps.map((step, i) => {
                const isActive = activeStep === i;

                return (
                    <button
                        key={step.week}
                        type="button"
                        role="tab"
                        onClick={() => onStepClick(i)}
                        aria-selected={isActive}
                        aria-controls={panelId}
                        className={cn(
                            "relative flex flex-col items-center gap-2 z-[1] px-1",
                            "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary300 rounded"
                        )}
                    >
                        <TimelineDot isActive={isActive} inactiveSize={9} />
                        <Paragraph
                            weight="500"
                            className={cn(
                                "text-[13.68px] uppercase tracking-[1.094px] leading-[1.25] transition-all duration-300",
                                isActive ? "text-primary500" : "text-gray400"
                            )}
                        >
                            {step.week}
                        </Paragraph>
                    </button>
                );
            })}
        </div>
    );
};

export default MobileWeekNav;
